
import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { Combo2Service } from "../../../services/index";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
    SalesOrderService
} from "../../../services/index";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
// import { PrintWorkOrder } from "./printWO";
// import { workorderprint } from "./woprint";
declare var google;

@Component({
    selector: "sales-return bundle",
    host: { "(window:keydown)": "hotkeys($event)" },
    templateUrl: "./factorydel_plan.html",
  })

export class factorydel_plan implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
//   orderList: any = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc"
  };
  filter = {
    status:'PENDING',
    fin_id : ''
  }
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  statusList =["COMPLETED", "PENDING"];
 

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("convertTemplate") convertTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  returnList: any = [];
  user: any;
  update_id :number;
  agentVisible: boolean = false;
  showApprove : boolean = false;
  showColumns : boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private combo2Service: Combo2Service,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    // this.data = {
    //   grnList: [],
    // };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  addEditstock(mode: string, row: any): void {
    // this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
    //   this.filterExpand = true;

    this.getcommissionMasterList()
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};

    if(mode == "Add"){
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "FACTORY DELIVERYPLAN ENTRY",
          title: "FACTORY DELIVERYPLAN ENTRY",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "addFactorydelPlan",
        },
      };
    }
  
    else if(mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "FACTORY DELIVERYPLAN ENTRY",
          title: "FACTORY DELIVERYPLAN ENTRY",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "addFactorydelPlan",
        },
      };
    }
    
    else if(mode == "Edit"){
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "FACTORY DELIVERYPLAN ENTRY",
          title: "FACTORY DELIVERYPLAN ENTRY",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "addFactorydelPlan",
        },
      };
    }
    this.tabUpdateEvent.emit(tabObj);
  }
  addEditinvoice(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
    //   this.filterExpand = true;

    this.getcommissionMasterList()
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Convert_type") {
      tabObj = {
        action: "NewTab",
        params: {
           //  tabParent: 'Transaction',
           tabName: "ADD SALES INVOICE RETURN",
           title: "ADD SALES INVOICE RETURN",
           tabParent: "SALES_PLAN",
           mode: mode,
           data: row,
           list: this.returnList,
           name: "ADD SALES INVOICE RETURN",
        },
      };
    }
  
    this.tabUpdateEvent.emit(tabObj);
    
  }

  getColumns() {

    this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center"
        },
        {
          name: "APPROVER",
          prop: "entry_by",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 130,
          maxWidth: 130,
          width: 130
        },
  
        {
          name: "ENTRY.DATE",
          prop: "date_formated",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140
        },
        {
          name: "TOT.PLAN.QTY",
          prop: "tot_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140
        },
        
          {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate
        }
        // {
        //   name: "Convert",
        //   prop: "sno",
        //   minWidth: 100,
        //   maxWidth: 120,
        //   width: 110,
        //   sortable: false,
        //   cellTemplate: this.convertTemplate
        // }
  
      ];
      this.finyearCombo();
 
    this.toggleCol = Object.assign({}, this.columns);

}

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getcommissionMasterList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.fin_id = "";
    this.filter.status ='PENDING';
    this.filterPanel.close();
    this.getColumns();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getcommissionMasterList();
  }
  gobacktoGroup(){
    this.showApprove = false;
    // this.filter.wo_ret_id = "";
    this.showColumns = true;
    this.getColumns();
    // this.getColumns();

  }
  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      this.pageCallback({ offset: 0 });

    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  getcommissionMasterList(): void {
     let params ={
        page: 1,
        start: 0,
        limit: 100,
    
     };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getFactoryDelplanList(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.orderList = res.data;
      });
  }

}

















// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/factoryDelPlan/factorydel_plan.ts